module.exports = new __parcel__URL__("padlock_Light mode_spot.5a1eeebb.svg").toString();